document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname === '/account/subscribe') {
    // Leichte Verzögerung, damit Shopify die Bestätigung registriert
    setTimeout(function() {
      window.location.href = '/pages/danke-newsletter';
    }, 10); // 0,01 Sekunde
  }
});
